import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ucraft/ucraft-next/src/components/pages/NotFound/notFound.tsx");
